import React, { useState, useEffect } from 'react';
import Icon from '@ant-design/icons';
import { fetchWeatherApi } from 'openmeteo';
import BasicConfig from '@/config/basic';
import './CalendarDashboard.less';

const SunnySvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path d="M512 256a256 256 0 1 0 0 512 256 256 0 0 0 0-512z m0 448a192 192 0 1 1 0-384 192 192 0 0 1 0 384z M512 128a32 32 0 0 0 32-32V32a32 32 0 0 0-64 0v64a32 32 0 0 0 32 32z M512 896a32 32 0 0 0-32 32v64a32 32 0 0 0 64 0v-64a32 32 0 0 0-32-32z M928 480h-64a32 32 0 0 0 0 64h64a32 32 0 0 0 0-64z M160 480H96a32 32 0 0 0 0 64h64a32 32 0 0 0 0-64z M807.936 170.56a32 32 0 0 0-45.248 0l-45.248 45.248a32 32 0 0 0 45.248 45.248l45.248-45.248a32 32 0 0 0 0-45.248z M261.056 762.944a32 32 0 0 0-45.248 0l-45.248 45.248a32 32 0 0 0 45.248 45.248l45.248-45.248a32 32 0 0 0 0-45.248z M807.936 853.44l-45.248-45.248a32 32 0 0 0-45.248 45.248l45.248 45.248a32 32 0 0 0 45.248-45.248z M261.056 261.056l-45.248-45.248a32 32 0 0 0-45.248 45.248l45.248 45.248a32 32 0 0 0 45.248-45.248z" />
  </svg>
);

const CloudySvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path d="M811.2 467.2c-12.8-153.6-140.8-272-297.6-272-121.6 0-230.4 76.8-272 188.8C134.4 409.6 51.2 512 51.2 633.6c0 140.8 115.2 256 256 256h460.8c115.2 0 204.8-89.6 204.8-204.8 0-108.8-76.8-198.4-161.6-217.6zM768 825.6H307.2c-105.6 0-192-86.4-192-192s86.4-192 192-192h12.8c25.6-115.2 128-198.4 243.2-198.4 134.4 0 249.6 108.8 249.6 249.6v19.2c76.8 12.8 134.4 76.8 134.4 153.6-6.4 89.6-83.2 160-179.2 160z" />
  </svg>
);

const RainSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path d="M811.2 467.2c-12.8-153.6-140.8-272-297.6-272-121.6 0-230.4 76.8-272 188.8C134.4 409.6 51.2 512 51.2 633.6c0 140.8 115.2 256 256 256h460.8c115.2 0 204.8-89.6 204.8-204.8 0-108.8-76.8-198.4-161.6-217.6zM768 825.6H307.2c-105.6 0-192-86.4-192-192s86.4-192 192-192h12.8c25.6-115.2 128-198.4 243.2-198.4 134.4 0 249.6 108.8 249.6 249.6v19.2c76.8 12.8 134.4 76.8 134.4 153.6-6.4 89.6-83.2 160-179.2 160z" />
    <path d="M352 928a32 32 0 0 1-28.8-48l48-96a32 32 0 0 1 57.6 28.8l-48 96A32 32 0 0 1 352 928zM512 928a32 32 0 0 1-28.8-48l48-96a32 32 0 0 1 57.6 28.8l-48 96A32 32 0 0 1 512 928zM672 928a32 32 0 0 1-28.8-48l48-96a32 32 0 0 1 57.6 28.8l-48 96A32 32 0 0 1 672 928z" />
  </svg>
);

const SnowSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path d="M811.2 467.2c-12.8-153.6-140.8-272-297.6-272-121.6 0-230.4 76.8-272 188.8C134.4 409.6 51.2 512 51.2 633.6c0 140.8 115.2 256 256 256h460.8c115.2 0 204.8-89.6 204.8-204.8 0-108.8-76.8-198.4-161.6-217.6zM768 825.6H307.2c-105.6 0-192-86.4-192-192s86.4-192 192-192h12.8c25.6-115.2 128-198.4 243.2-198.4 134.4 0 249.6 108.8 249.6 249.6v19.2c76.8 12.8 134.4 76.8 134.4 153.6-6.4 89.6-83.2 160-179.2 160z" />
    <circle cx="368" cy="904" r="24" />
    <circle cx="512" cy="936" r="24" />
    <circle cx="656" cy="904" r="24" />
  </svg>
);

const FogSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path d="M811.2 467.2c-12.8-153.6-140.8-272-297.6-272-121.6 0-230.4 76.8-272 188.8C134.4 409.6 51.2 512 51.2 633.6c0 140.8 115.2 256 256 256h460.8c115.2 0 204.8-89.6 204.8-204.8 0-108.8-76.8-198.4-161.6-217.6zM768 825.6H307.2c-105.6 0-192-86.4-192-192s86.4-192 192-192h12.8c25.6-115.2 128-198.4 243.2-198.4 134.4 0 249.6 108.8 249.6 249.6v19.2c76.8 12.8 134.4 76.8 134.4 153.6-6.4 89.6-83.2 160-179.2 160z" />
    <rect x="192" y="880" width="640" height="32" rx="16" />
    <rect x="256" y="944" width="512" height="32" rx="16" />
  </svg>
);

const ThunderSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path d="M811.2 467.2c-12.8-153.6-140.8-272-297.6-272-121.6 0-230.4 76.8-272 188.8C134.4 409.6 51.2 512 51.2 633.6c0 140.8 115.2 256 256 256h460.8c115.2 0 204.8-89.6 204.8-204.8 0-108.8-76.8-198.4-161.6-217.6zM768 825.6H307.2c-105.6 0-192-86.4-192-192s86.4-192 192-192h12.8c25.6-115.2 128-198.4 243.2-198.4 134.4 0 249.6 108.8 249.6 249.6v19.2c76.8 12.8 134.4 76.8 134.4 153.6-6.4 89.6-83.2 160-179.2 160z" />
    <path d="M544 864l-96 160h64l-32 128 128-176h-72l48-112z" />
  </svg>
);

const WeatherIcon = ({ type, ...rest }) => {
  const svgMap = {
    sunny: SunnySvg,
    cloudy: CloudySvg,
    rain: RainSvg,
    snow: SnowSvg,
    fog: FogSvg,
    thunder: ThunderSvg,
  };
  return <Icon component={svgMap[type] || CloudySvg} {...rest} />;
};

const WEATHER_CODE_MAP = {
  0: '晴天',
  1: '大部晴朗',
  2: '部分多云',
  3: '阴天',
  45: '雾',
  48: '雾',
  51: '小雨',
  53: '中雨',
  55: '大雨',
  56: '冻雨',
  57: '强冻雨',
  61: '小雨',
  63: '中雨',
  65: '大雨',
  66: '冻雨',
  67: '强冻雨',
  71: '小雪',
  73: '中雪',
  75: '大雪',
  77: '雪粒',
  80: '小雨',
  81: '中雨',
  82: '大雨',
  85: '小雪',
  86: '大雪',
  95: '雷暴',
  96: '雷暴冰雹',
  99: '强雷暴冰雹',
};

const getWeatherDescription = (code) => WEATHER_CODE_MAP[code] || '未知';

/**
 * 通过高德地图逆地理编码获取位置名称
 * @returns {string|null} "城市/区" 格式的位置字符串，失败返回 null
 */
const fetchLocationByAmap = async (lat, lon) => {
  const amapKey = BasicConfig.amapKey;
  if (!amapKey) return null;

  const res = await fetch(
    `https://restapi.amap.com/v3/geocode/regeo?key=${amapKey}&location=${lon},${lat}&output=json`
  );
  if (!res.ok) return null;

  const data = await res.json();
  if (data.status !== '1' || !data.regeocode) return null;

  const addr = data.regeocode.addressComponent;
  const city =
    addr.city ||
    (addr.province ? addr.province.replace(/省|市|自治区|特别行政区/g, '') : '');
  const district = addr.district || '';

  return city ? `${city}/${district}` : null;
};

/**
 * 通过 IP 定位获取位置名称（ipapi.co）
 * @returns {string|null}
 */
const fetchLocationByIP = async () => {
  const res = await fetch('https://ipapi.co/json/');
  if (!res.ok) return null;

  const data = await res.json();
  return data.city ? `${data.city}/` : null;
};

/**
 * 通过 openmeteo SDK 获取天气数据
 * SDK 内置重试机制，无需手动 fallback
 */
const fetchWeather = async (latitude, longitude) => {
  const params = {
    latitude: [latitude],
    longitude: [longitude],
    current: 'temperature_2m,weather_code',
    timezone: 'Asia/Shanghai',
  };

  const responses = await fetchWeatherApi(
    'https://api.open-meteo.com/v1/forecast',
    params
  );

  const current = responses[0].current();
  return {
    temperature: Math.round(current.variables(0).value()),
    weatherDescription: getWeatherDescription(current.variables(1).value()),
  };
};

/**
 * 无经纬度时，使用默认参数（上海）获取天气
 */
const fetchWeatherFallback = async () => {
  const params = {
    latitude: [31.23],
    longitude: [121.47],
    current: 'temperature_2m,weather_code',
    timezone: 'Asia/Shanghai',
  };

  const responses = await fetchWeatherApi(
    'https://api.open-meteo.com/v1/forecast',
    params
  );

  const current = responses[0].current();
  return {
    temperature: Math.round(current.variables(0).value()),
    weatherDescription: getWeatherDescription(current.variables(1).value()),
  };
};

const CalendarDashboard = () => {
  const [unit, setUnit] = useState('C');
  const [currentTime, setCurrentTime] = useState(new Date());
  const [location, setLocation] = useState('获取位置中...');
  const [weatherData, setWeatherData] = useState({
    temperature: null,
    weatherDescription: '获取中...',
  });

  useEffect(() => {
    let cancelled = false;

    const init = async () => {
      try {
        const coords = await new Promise((resolve, reject) => {
          if (!navigator.geolocation) {
            reject(new Error('Geolocation not supported'));
            return;
          }
          navigator.geolocation.getCurrentPosition(
            (pos) => resolve(pos.coords),
            reject,
            { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
          );
        });

        if (cancelled) return;

        const [loc, weather] = await Promise.allSettled([
          fetchLocationByAmap(coords.latitude, coords.longitude),
          fetchWeather(coords.latitude, coords.longitude),
        ]);

        if (cancelled) return;

        const locationText =
          loc.status === 'fulfilled' && loc.value
            ? loc.value
            : `${coords.latitude.toFixed(2)}, ${coords.longitude.toFixed(2)}`;
        setLocation(locationText);

        if (weather.status === 'fulfilled') {
          setWeatherData(weather.value);
        }
      } catch {
        if (cancelled) return;

        const [loc, weather] = await Promise.allSettled([
          fetchLocationByIP(),
          fetchWeatherFallback(),
        ]);

        if (cancelled) return;

        setLocation(
          loc.status === 'fulfilled' && loc.value
            ? loc.value
            : '未知位置'
        );

        if (weather.status === 'fulfilled') {
          setWeatherData(weather.value);
        } else {
          setWeatherData({ temperature: null, weatherDescription: '获取失败' });
        }
      }
    };

    init();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const now = new Date();
    const msUntilNextMinute =
      (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    let intervalTimer = null;

    const firstTimer = setTimeout(() => {
      setCurrentTime(new Date());
      intervalTimer = setInterval(() => {
        setCurrentTime(new Date());
      }, 60000);
    }, msUntilNextMinute);

    return () => {
      clearTimeout(firstTimer);
      if (intervalTimer) clearInterval(intervalTimer);
    };
  }, []);

  const formatTime = (date) => {
    const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${days[date.getDay()]} ${displayHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
  };

  const convertTemperature = (celsius) => {
    if (celsius === null || celsius === undefined) return '--';
    if (unit === 'F') return Math.round((celsius * 9) / 5 + 32);
    return celsius;
  };

  const displayTemp = convertTemperature(weatherData.temperature);

  const getWeatherIconType = () => {
    const desc = weatherData.weatherDescription || '';
    if (desc.includes('晴')) return 'sunny';
    if (desc.includes('雷')) return 'thunder';
    if (desc.includes('雪') || desc.includes('雪粒')) return 'snow';
    if (desc.includes('雨') || desc.includes('冻雨')) return 'rain';
    if (desc.includes('雾')) return 'fog';
    return 'cloudy';
  };

  const toggleUnit = () => setUnit((prev) => (prev === 'C' ? 'F' : 'C'));

  return (
    <div className="weather-widget-card">
      <div className="weather-widget">
        <div className="weather-location">{location}</div>
        <div className="weather-time">{formatTime(currentTime)}</div>
        <div className="weather-main-row">
          <div className="weather-temp-section">
            <WeatherIcon type={getWeatherIconType()} className="weather-icon" />
            <span className="weather-temp">{displayTemp}°</span>
          </div>
          <div className="weather-unit-toggle">
            <span className={`unit-label ${unit === 'C' ? 'active' : ''}`}>°C</span>
            <div className="toggle-switch" onClick={toggleUnit}>
              <div className={`toggle-handle ${unit === 'C' ? 'left' : 'right'}`}></div>
            </div>
            <span className={`unit-label ${unit === 'F' ? 'active' : ''}`}>°F</span>
          </div>
        </div>
        <div className="weather-description">{weatherData.weatherDescription}</div>
      </div>
    </div>
  );
};

export default CalendarDashboard;
